import React from 'react';

import styles from './PriceCheckInformation.less';

type PriceCheckInfoProps = {
  text: string;
};

const PriceCheckInfo = ({ text }: PriceCheckInfoProps): JSX.Element => (
  <div className={`grid grid-flex margin-left-s ${styles.container}`}>
    <div className="grid-item one-tenth">
      <span className="is24-icon-positive-check font-confirm font-xl" />
    </div>
    <div className="grid-item nine-tenth">
      <span className="padding-left-s font-standard font-light">{text}</span>
    </div>
  </div>
);

export default PriceCheckInfo;
